// extracted by mini-css-extract-plugin
export default {"InviteButton":"InviteButton_InviteButton__+EJV-"};